import React, { Component } from 'react'
import { connect } from 'react-redux'

import '../../assets/css/tor-template-list.css'
import $ from 'jquery'
import { SecureGateRoute, BreadCrumb, DetailBotLogModal } from '../../components'
import { searchReportAction, exportReportAction } from '../../redux/actions/SearchAction'
import { AppSettings } from '../../configs'
import { Storage } from '../../configs'
import {
    data_status,
} from '../../configs/datas'
import moment from 'moment'
import { msg } from '../../components/Notifications/MsgBox'
import ReactTooltip from 'react-tooltip'
import ReceiptTablePage from '../../components/ReportReceipt/ReceiptTablePage'
import html2canvas from 'html2canvas'
import { jsPDF } from 'jspdf'

class ReportReceiptPDFScreen extends Component {
    constructor (props) {
        super(props)
        this.state = {}
        this.checkText = this.checkText.bind(this)
    }

    renderPDF () {

        var HTML_Width = $('#main-content').width()
        var HTML_Height = $('#main-content').height()

        var top_left_margin = 25
        var PDF_Width = HTML_Width + (top_left_margin * 1.5)
        var PDF_Height = (PDF_Width) + (top_left_margin * 2.5)
        var canvas_image_width = HTML_Width
        var canvas_image_height = HTML_Height * 1

        var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1
        if (totalPDFPages === 0) {
            //totalPDFPages = 1;
        }
        console.log('HTML_Height:' + HTML_Height)
        console.log('PDF_Height:' + PDF_Height)
        console.log($('#main-content')[0])
        html2canvas($('#main-content')[0], { allowTaint: false, letterRendering: false })
            .then(function (canvas) {

                canvas.getContext('a4')
                console.log(canvas.height + '  ' + canvas.width)
                var imgData = canvas.toDataURL('image/jpeg', 1.0)
                //console.log(imgData);
                var pdf = new jsPDF('p', 'pt', [PDF_Width, PDF_Height])
                pdf.addImage(imgData, 'PNG', top_left_margin, top_left_margin, canvas_image_width, canvas_image_height)

                for (var i = 1; i <= totalPDFPages; i++) {
                    pdf.addPage(PDF_Width, PDF_Height)
                    pdf.addImage(imgData, 'JPG', top_left_margin, -(PDF_Height * i) + (top_left_margin * 4), canvas_image_width, canvas_image_height)
                }
                // window.location.href = (pdf.output("datauristring",{filename:"html2pdf.pdf"}))
                // pdf.output("dataurlnewwindow")
                // pdf.save("html2pdf.pdf");
                // window.open(URL.createObjectURL(blob));
            })

    }

    componentDidMount () {

    }

    checkText (text) {
        return text ? text : '.........'
    }

    checkCheckBox (value) {

        if (value == null) {
            return false
        }

        return value.toUpperCase() == 'N' || value.toUpperCase == 'FALSE' ? false : true
    }

    checkTextWarp (text, strLen) {
        var txtWrap = ''
        const firstTxt = ('ก').charCodeAt(0)
        const lastTxt = ('ฮ').charCodeAt(0)
        var wait_wrap = false

        for (var i = 0; i < text.length; i++) {

            var thatTxt = text[i].charCodeAt(0)

            txtWrap += text[i]
            if (
                ((i % strLen == 0 && i != 0) && thatTxt >= firstTxt && thatTxt <= 3632)
                || (wait_wrap == true && thatTxt >= firstTxt && thatTxt <= 3632)
            ) {
                txtWrap += ` `
                wait_wrap = false
            } else if ((i % strLen == 0 && i != 0) && (thatTxt < firstTxt || thatTxt > lastTxt)) {

                wait_wrap = true
            } else {
                wait_wrap = false
            }

        }
        return txtWrap
    }

    renderDate (strDate) {
        return strDate ? strDate.split(' ')[0] : '.........'
    }

    render () {

        const { resultPDF, resultPDFCommittee } = this.props
        let approveCount = 0

        return (
            <div className="tor tor-template-list">
                {/*<SecureGateRoute/>*/ }
                <div id="pdf-page" style={ { fontSize: '10px', lineHeight: '18px' } }>
                    <div className="page-body">
                        <div className="container-fluid bordered" style={ { minHeight: '297mm', width: '210mm' } }>
                            <div id="header_pdf" className="d-flex media-body">
                                <div className="col-2 logo-img border border-dark d-flex justify-content-center p-2"
                                     style={ { flex: 1 } }>
                                    <img src="/assets/images/ptt-logo-s.png"/>
                                </div>
                                <div className="col-6 border border-dark d-flex justify-content-center p-2"
                                     style={ { flex: 3 } }>รายงานการประชุมตรวจรับพัสดุ
                                </div>
                                <div className="col-4 border border-dark d-flex justify-content-center p-2"
                                     style={ { flex: 3 } }>เลขที่ { this.checkText(resultPDF.moM_DOC_NO) }</div>
                            </div>

                            <div className="d-flex media-body">
                                <div className="col-8 border border-dark d-flex justify-content-center p-2"
                                     style={ { flex: 4, flexDirection: 'column' } }>
                                    <span>หน่วยงาน { this.checkText(resultPDF.requisitioner) }</span>
                                    <span>ผู้ขาย / ผู้จ้าง { this.checkText(resultPDF.vendoR_NAME) }</span>
                                </div>
                                <div className="col-4 border border-dark d-flex justify-content-center p-2"
                                     style={ { flex: 3, flexDirection: 'column' } }>
                                    <span>PO No. / Contract No. { this.checkText(resultPDF.pO_CONTRACT_NO) }</span>
                                    <span>การตรวจรับงวดที่ { this.checkText(resultPDF.moM_CHECK_PHASE) }</span>
                                    <span>
                                        <input type={ 'checkbox' }
                                               style={ { marginRight: '5px' } }
                                               checked={ this.checkCheckBox(resultPDF.finaL_FLAG) }/>
                                        งวดสุดท้าย
                                    </span>
                                </div>
                            </div>

                            <div className="d-flex media-body">
                                <div className="col border border-dark d-flex  p-2" style={ { flex: 1 } }>
                                    <span> ชื่องาน { this.checkText(resultPDF.headeR_TEXT) }</span>
                                </div>
                            </div>

                            <div className="d-flex media-body">
                                <div className="col border border-dark d-flex p-2"
                                     style={ { flex: 1, flexDirection: 'column' } }>
                                    <span> วันที่ส่งมอบถูกต้องครบถ้วน { this.checkText(resultPDF.perioD_END) }</span>
                                    <span> รายละเอียดเพิ่มเติม
                                        (ถ้ามี) { this.checkText(resultPDF.doC_DESRIPTION) }</span>
                                </div>
                            </div>

                            <div className="d-flex media-body">
                                <div className="col-2 border border-dark d-flex justify-content-center p-2">
                                    <u> ผู้ตรวจรับพัสดุ</u>
                                </div>
                                <div className="col-10 border border-dark d-flex justify-content-center p-2">
                                    <u> ที่ประชุมมีมติเมื่อวันที่ { this.renderDate(resultPDF.moM_DATE) }</u>
                                </div>
                            </div>

                            <div>
                                {
                                    resultPDFCommittee.map((committee) => {

                                        if (this.checkCheckBox(committee.approvE_STATUS)) {
                                            approveCount += 1
                                        }

                                        return <div className={ 'd-flex  media-body' } style={ { height: '100px' } }>
                                            <div className="col-2 border border-dark justify-content-center p-2">
                                                <p> { committee.fullname || '' } </p>
                                            </div>
                                            <div className="col-1 border border-dark d-flex justify-content-center p-2">
                                                <p> { committee.code || '' } </p>
                                            </div>
                                            <div className="col-2 border border-dark px-3 py-2">
                                                <div className="box">
                                                    <u></u>
                                                    <div className="committee-department justify-content-left p-0">
                                                        { this.checkTextWarp(committee.department, 17) }
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="col-3 border border-dark d-flex justify-content-center">
                                                <div className="d-flex flex-column m-2">
                                                    <p> ผลการตรวจรับพัสดุ*</p>
                                                    <p>
                                                        <input type={ 'checkbox' }
                                                               style={ { marginRight: '5px' } }
                                                               checked={ this.checkCheckBox(committee.approvE_STATUS) }/>
                                                        อนุมัติตรวจรับ
                                                    </p>
                                                    <p>
                                                        <input type={ 'checkbox' }
                                                               style={ { marginRight: '5px' } }
                                                               checked={ !this.checkCheckBox(committee.approvE_STATUS) }/>
                                                        ไม่อนุมัติตรวจรับ
                                                    </p>
                                                </div>

                                            </div>
                                            <div className="col-4 border border-dark p-2">
                                                <div className="box">
                                                    <u> ความเห็นเพิ่มเติม : </u>
                                                    <div className="committee-comment justify-content-left"
                                                         style={ { paddingLeft: '15px' } }>
                                                        { this.checkTextWarp(committee.department + committee.department, 36) }
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    })
                                }

                            </div>

                            <div className="d-flex media-body">
                                <div className="col border border-dark d-flex  p-2"
                                     style={ { flex: 1, flexDirection: 'column', fontSize: '12px' } }>
                                    <div style={ { display: 'flex', minHeight: '50px', flexDirection: 'column' } }>
                                        <u>มติที่ประชุม :</u>
                                        { this.props.resultPDFCommittee.length == 3 && approveCount == 3 ?
                                          <span style={ { textIndent: '20px' } }>
                                              { 'คณะกรรมการตรวจรับสินค้ามีมติเอกฉันท์ โดยผลการตรวจรับถูกต้องครบถ้วน' }
                                          </span>
                                                                                                         :
                                          <div>
                                              <p style={ { marginLeft: '20px' } }>
                                                  { 'คณะกรรมการตรวจรับสินค้ามีมติไม่เป็นเอกฉันท์ โดยมีความเห็นแย้ง และตามใบบันทึกเลขที่ '
                                                  + this.checkText(resultPDF.moM_DOC_NO) + ' เมื่อวันที่ '
                                                  + (this.renderDate(resultPDF.moM_DATE)) }
                                              </p>
                                              <p>พิจารณาแล้วมีความเห็นให้อนุมัติตรวจรับ</p>
                                          </div>
                                        }
                                    </div>
                                    <div style={ { display: 'flex' } }>

                                        <span>ค่าปรับ</span>
                                        <div style={ {
                                            display: 'flex',
                                            flexDirection: 'column',
                                            paddingLeft: '20px',
                                        } }>
                                            <span>
                                                <input type="checkbox" style={ { marginRight: '5px' } }
                                                       checked={ this.checkCheckBox(resultPDF.nO_PENALTY_FLAG) }/> ไม่ค่าปรับ
                                            </span>
                                            <span>
                                                <input type={ 'checkbox' } style={ { marginRight: '5px' } }
                                                       checked={ this.checkCheckBox(resultPDF.penaltY_FLAG) }/> มีค่าปรับ
                                            </span>
                                            <div style={ {
                                                paddingLeft: '20px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                            } }>
                                                <span>
                                                    <input type={ 'checkbox' } style={ { marginRight: '5px' } }
                                                           checked={ this.checkCheckBox(resultPDF.delaY_DAY_NO) }/>
                                                    ส่งมอบล่าช้ากว่ากำหนด { this.checkText(resultPDF.delaY_DAY_NO) } วัน
                                                    เนื่องจาก { this.checkText(resultPDF.delaY_REMARK) } </span>
                                                <span>
                                                    <input type={ 'checkbox' } style={ { marginRight: '5px' } }
                                                           checked={ this.checkCheckBox(resultPDF.penaltY_AMOUNT) }/>
                                                    คิดค่าปรับในอัตราวันละ { this.checkText(resultPDF.penaltY_AMOUNT) } บาท
                                                    คิดเป็นเงินค่าปรับ { this.checkText(resultPDF.penaltY_RESULT) } บาท
                                                </span>
                                                <span>
                                                    <input type={ 'checkbox' } style={ { marginRight: '5px' } }
                                                           checked={ this.checkCheckBox(resultPDF.otheR_PENALTY_FLAG) }/>
                                                    ค่าปรับอื่นๆเป็นจำนวนเงิน { this.checkText(resultPDF.otheR_PENALTY_AMOUNT) } THB
                                                    เนื่องจาก { this.checkText(resultPDF.otheR_PENALTY_REMARK) }</span>
                                                <span>
                                                    <input type={ 'checkbox' } style={ { marginRight: '5px' } }
                                                           checked={ this.checkCheckBox(resultPDF.exceptioN_FLAG) }/>
                                                    <span style={ { textIndent: '20px' } }>
                                                        ลด / งด / ยกเว้นค่าปรับ ตามหนังสืออนุมัติ
                                                        เลขที่ { this.checkText(resultPDF.exceptioN_DOC_NO) } ลงวันที่ { this.renderDate(resultPDF.exceptioN_DOC_DATE) }
                                                        <br/>
                                                        ทั้งนี้ ปตท. ได้มีหนังสือแจ้งสิทธิ์การเรียกค่าปรับ
                                                        เลขที่ { this.checkText(resultPDF.penaltY_NOTIFY_NO) } ลงวันที่ { this.renderDate(resultPDF.penaltY_RESERVED_DATE) }
                                                        <br/>
                                                        และหนังสือแจ้งสงวนสิทธิ์การเรียกค่าประบ
                                                        เลขที่ { this.checkText(resultPDF.penaltY_RESERVED_NO) } ลงวันที่ { this.renderDate(resultPDF.penaltY_RESERVED_DATE) }
                                                    </span>

                                                </span>
                                            </div>
                                            <span>
                                                <input type={ 'checkbox' } style={ { marginRight: '5px' } }
                                                       checked={ this.checkCheckBox(resultPDF.dowN_DEPT_FLAG) }/>
                                                ใบลดหนี้ งวดที่ { this.checkText(resultPDF.dowN_DEPT_PERIOD) }
                                                เลขที่ { this.checkText(resultPDF.dowN_DEPT_NO) } ลงวันที่ { this.renderDate(resultPDF.dowN_DEPT_DATE) }
                                            </span>
                                            <span>
                                                <input type={ 'checkbox' } style={ { marginRight: '5px' } }
                                                       checked={ this.checkCheckBox(resultPDF.uP_DEPT_FLAG) }/>
                                                ใบเพิ่มหนี้ งวดที่ { this.checkText(resultPDF.uP_DEPT_PERIOD) }
                                                เลขที่ { this.checkText(resultPDF.uP_DEPT_NO) } ลงวันที่ { this.renderDate(resultPDF.uP_DEPT_DATE) }
                                            </span>
                                        </div>

                                    </div>
                                    <div style={ { display: 'flex', flexDirection: 'column' } }>
                                        <span> จำนวนเงินค่าปรับรวม { this.checkText(resultPDF.penaltY_RESULT) } THB
                                            จำนวนเงินหักค่าประกัน(Retention) { this.checkText(resultPDF.retentioN_AMOUNT) } THB
                                            จำนวนเงินหัก(Advance
                                            Payment) { this.checkText(resultPDF.advancE_AMOUNT) } THB
                                        </span>
                                        <span> จำนวนเงินลดหนี้ { this.checkText(resultPDF.dowN_DEPT_AMOUNT) } THB
                                            จำนวนเงินเพิ่มหนี้ { this.checkText(resultPDF.uP_DEPT_AMOUNT) } THB
                                            จำนวนเงินคงเหลือสุทธิ { this.checkText(resultPDF.penaltY_NET) } THB
                                        </span>
                                    </div>

                                </div>

                            </div>


                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

export default (ReportReceiptPDFScreen)